import React from 'react';
import type { Clase, EstrategiaOrg } from '../../types';
import { CHECKS_LOGISTICA, ESTRATEGIAS } from '../../data/constantes';
import { Tarjeta } from '../ui/Tarjeta';
import { CampoArea, CampoNumero, CampoSelect, Casilla } from '../ui/Campo';
import { Aviso } from '../ui/Aviso';
interface Props {
  clase: Clase;
  actualizar: (parcial: Partial<Clase>) => void;
}
export function Paso2Logistica({
  clase,
  actualizar
}: Props) {
  const sinConfirmar = CHECKS_LOGISTICA.filter(c => !clase.logistica.checks[c.id]).length;
  const cambiarCheck = (id: string, valor: boolean) => {
    actualizar({
      logistica: {
        ...clase.logistica,
        checks: {
          ...clase.logistica.checks,
          [id]: valor
        }
      }
    });
  };
  return <div className="space-y-4" data-id="element-118" data-mp="14bq013x0u2m9">
      <Tarjeta data-id="element-119" data-mp="14crkfyzxg1gn">
        <h2 className="text-lg font-bold text-tinta-titulo" data-id="element-120" data-mp="2tq4gl0xvyj6o">Prepará el espacio y la organización</h2>
        <p className="mt-1 text-sm text-tinta-sec" data-id="element-121" data-mp="2yoo5na7s0b39">
          Los controles son un recordatorio de revisión. No bloquean el asistente.
        </p>
        <div className="mt-4 divide-y divide-linea" data-id="element-122" data-mp="3oof4wpmu1ce">
          {CHECKS_LOGISTICA.map(c => <div key={c.id} className="py-1" data-id="element-123" data-mp="3vt8p4wn10n7q">
              <Casilla etiqueta={c.texto} checked={Boolean(clase.logistica.checks[c.id])} onChange={v => cambiarCheck(c.id, v)} data-id="element-124" data-mp="dg151irvehfs" />
            </div>)}
        </div>

        {sinConfirmar > 0 && <Aviso tipo="aviso" className="mt-4" titulo="Controles sin confirmar" data-id="element-125" data-mp="3gx16i0r9ntuk">
            Quedaron {sinConfirmar} controles sin confirmar. Podés continuar bajo tu criterio
            profesional, pero revisalos antes de comenzar la clase.
          </Aviso>}
      </Tarjeta>

      <Tarjeta data-id="element-126" data-mp="3lu9j7ltnb5of">
        <h2 className="text-lg font-bold text-tinta-titulo" data-id="element-127" data-mp="3lxxbyir9no23">Organización del grupo</h2>
        <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2" data-id="element-128" data-mp="162vdtifbrsdf">
          <CampoSelect etiqueta="Estrategia" value={clase.logistica.estrategia} opciones={ESTRATEGIAS} onChange={e => actualizar({
          logistica: {
            ...clase.logistica,
            estrategia: e.target.value as EstrategiaOrg
          }
        })} data-id="element-129" data-mp="114k4d8sxzjvq" />
          <CampoNumero etiqueta="Profes o asistentes" min={1} max={20} value={clase.logistica.profes} onChange={e => actualizar({
          logistica: {
            ...clase.logistica,
            profes: Number(e.target.value)
          }
        })} data-id="element-130" data-mp="1i7sl5kqgds5f" />
        </div>
        <div className="mt-4" data-id="element-131" data-mp="zfzuhwyuwj0v">
          <CampoArea etiqueta="Nota logística" value={clase.logistica.nota} ayuda="Por ejemplo: quién observa cada estación, cómo rota el grupo o qué material hace falta." onChange={e => actualizar({
          logistica: {
            ...clase.logistica,
            nota: e.target.value
          }
        })} data-id="element-132" data-mp="zfq4489wg9un" />
        </div>

        {clase.participantes > clase.puntos && clase.logistica.estrategia !== 'Estaciones' && clase.logistica.estrategia !== 'Rotaciones' && <Aviso tipo="aviso" className="mt-4" titulo="Más participantes que puntos" data-id="element-133" data-mp="3vbmjg5zo91rd">
              Definí una estrategia de rotación o estaciones para que todo el grupo tenga tiempo de
              trabajo.
            </Aviso>}
      </Tarjeta>
    </div>;
}